import { PromiseToPay } from "@portal/BaseComponents/Activites/PromiseToPay/PromiseToPay";
import { RaiseDispute } from "@portal/BaseComponents/Activites/RaiseADispute/RaiseDispute";
import { Invoice, InvoiceStatusesConfig } from "@portal/types/entities/invoice";
import { BulkAction } from "@sinecycle/growcomponents";
import { head } from "lodash";
import { InvoiceActionPrivileges } from "../../InvoiceList";

function InvoiceActions(
  props: BulkAction<Invoice> & {
    privileges?: InvoiceActionPrivileges;
    invoiceStatusConfig: InvoiceStatusesConfig;
  }
) {
  if (!props.selectedRows) return;

  const data = head(props.selectedRows)?.data;
  if (!data) return;
  const PTP = (
    <PromiseToPay
      iconOnly
      open={props.selectedKey === "PTP"}
      iconColor="var(--primary-7)"
      showToolTip
      defaultInvoice={[data]}
      key={props.selectedKey}
      onclose={props.onClose}
    />
  );

  const Dispute = (
    <RaiseDispute
      open={props.selectedKey === "DISPUTE"}
      iconOnly
      iconColor="var(--primary-7)"
      showToolTip
      key={props.selectedKey}
      defaultInvoices={[data]}
      onclose={props.onClose}
    />
  );

  return (
    <>
      <>
        {Dispute}
        {PTP}
      </>
    </>
  );
}

export { InvoiceActions };
